import React from 'react';
import './style/ModalFrame.css';
import { lastModalTargetId } from 'app/ui/core/common/ModalTarget';

export default function withModalTargetDetection(Component) {
  return class ComponentWithModalTargetDetection extends React.Component {
    state = {
      id: null,
    };

    // This makes sure the target is up-to-date and available at initial mount
    componentDidMount() {
      this.setState({
        id: lastModalTargetId,
      });
    }

    render() {
      if (!this.state.id) {
        return null;
      }
      return (
        <Component
          {...this.props}
          parentSelector={() => document.querySelector(`#${this.state.id}`)}
        />
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/ui/core/common/withModalTargetDetection.js